import React, { useState, useRef } from 'react';
import { Card, Form, Button, Spinner, Image } from 'react-bootstrap';
import { uploadSiteLogo, deleteSiteLogo } from 'services/files';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const UploadSiteLogo = ({ siteId, onUploadSuccess, image_url }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState(image_url);
  const fileInputRef = useRef(null);
  console.log(
    'UploadSiteLogo component rendered with siteId:',
    siteId,
    'and image_url:',
    image_url
  );
  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!file) {
      toast.error('Por favor, selecciona un logo antes de subir.', {
        theme: 'colored'
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('image', file);
    formData.append('siteId', siteId);

    try {
      const response = await uploadSiteLogo(formData, siteId);
      if (response.result) {
        toast.success('Logo subido exitosamente.', { theme: 'colored' });
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setCurrentImageUrl(response.image_url);
        if (onUploadSuccess) onUploadSuccess(response);
      } else {
        toast.error(response.msg || 'Error al subir el logo.', {
          theme: 'colored'
        });
      }
    } catch (error) {
      console.error('Error al subir el logo:', error);
      toast.error(
        'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
        { theme: 'colored' }
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteImage = async () => {
    if (!currentImageUrl) return;

    setLoading(true);

    try {
      const response = await deleteSiteLogo(siteId); // Cambia si tienes deleteSiteLogo
      if (response.result) {
        toast.success('Logo eliminado exitosamente.', { theme: 'colored' });
        setCurrentImageUrl(null);
        if (onUploadSuccess) onUploadSuccess(null);
      } else {
        toast.error(response.msg || 'Error al eliminar el logo.', {
          theme: 'colored'
        });
      }
    } catch (error) {
      console.error('Error al eliminar el logo:', error);
      toast.error(
        'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
        { theme: 'colored' }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mt-4">
      <Card.Header>
        <h6 className="mb-0">Logo del sitio</h6>
      </Card.Header>
      <Card.Body>
        {currentImageUrl && (
          <div className="mb-3 text-center">
            <p className="text-muted mb-1">Logo actual</p>
            <Image
              src={currentImageUrl}
              alt="Logo actual"
              rounded
              fluid
              style={{ maxHeight: '200px', objectFit: 'cover' }}
            />
            <div className="mt-2">
              <Button
                variant="danger"
                size="sm"
                onClick={handleDeleteImage}
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  'Eliminar Logo'
                )}
              </Button>
            </div>
          </div>
        )}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label className="fw-bold">Subir Logo</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              disabled={loading}
            />
          </Form.Group>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Subir Logo'}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

UploadSiteLogo.propTypes = {
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onUploadSuccess: PropTypes.func,
  image_url: PropTypes.string
};

export default UploadSiteLogo;
